module.exports = __webpack_public_path__ + "img/saishianpai-right-icon.8d0e8f45.png";